import { Directive, ElementRef, HostListener, inject, output } from '@angular/core';

@Directive({
    selector: '[stbyClickOutside]',
})
export class ClickOutsideDirective {
    private _elementRef = inject(ElementRef);

    readonly clickOutside = output<MouseEvent>();

    @HostListener('document:click', ['$event', '$event.target'])
    onClick(event: MouseEvent, targetElement: HTMLElement): void {
        if (!targetElement) {
            return;
        }

        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(event);
        }
    }
}
